import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import "./phoneNumber.scss";
import classNames from "classnames";
import {
  ChangeEvent,
  FocusEvent,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import SvgIcon from "@/components/common/SvgIcon";
import { Typography } from "@/components/kit";

interface CountryData {
  name: string;
  dialCode: string;
  countryCode: string;
  format: string;
}

type TProps = {
  name: string;
  value: string | null | undefined;
  countryNo?: string;
  error?: string | boolean;
  onEnter?: () => void;
  onChange: (
    value: string,
    data: CountryData,
    event: ChangeEvent<HTMLInputElement>,
    formattedValue: string,
  ) => void;
  placeholder: string;
  onBlur?(
    event: FocusEvent<HTMLInputElement, Element>,
    data: CountryData,
  ): void;
  onFocus?(
    event: FocusEvent<HTMLInputElement, Element>,
    data: CountryData,
  ): void;
  className?: string;
};

const PhoneNumber = (props: TProps) => {
  const myRef = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState(200);

  const {
    name,
    value,
    countryNo,
    placeholder,
    error,
    onChange,
    onEnter,
    onBlur,
    onFocus,
    className = "",
  } = props;

  const iso = countryNo ? countryNo.toLocaleLowerCase() : "";

  useLayoutEffect(() => {
    if (myRef.current) {
      const w = myRef.current?.offsetWidth;
      setWidth(w);
    }
  }, [myRef]);

  return (
    <div>
      <div
        ref={myRef}
        className={classNames("", {
          err: !!error,
        })}
      >
        <PhoneInput
          onBlur={onBlur}
          onFocus={onFocus}
          country={iso}
          enableSearch={true}
          value={value}
          placeholder={placeholder}
          onChange={onChange}
          onEnterKeyPress={onEnter}
          dropdownStyle={{
            width: `${width}px`,
            height: "180px",
            minWidth: "200px",
          }}
          inputClass={classNames("phone-input", className, {
            err: !!error,
          })}
          inputProps={{ name }}
        />
      </div>
      {!!props.error && (
        <div className="error ps-2 pt-2 flex justify-start items-center gap-1">
          <SvgIcon
            className={"w-3 h-3"}
            fill="fill-red-600"
            iconName="attentionRed"
          />
          <Typography color={"text-red-600"} variant={"Caption1-Regular"}>
            {error}
          </Typography>
        </div>
      )}
    </div>
  );
};

export default PhoneNumber;
